import { Thunk } from 'store/types';
import { getErrorCode, getErrorMessage } from 'services/api/utils';
import { Dispatch } from 'redux';
import {
  KEY,
  Patient,
  Questionnaire,
  Subscriber,
  InsuranceCard,
  CovidScreeningState,
  OrderStatus
} from './types';

export const COVID_SCREENING_CONFIRM = 'COVID_SCREENING_CONFIRM';
export const COVID_SCREENING_HAS_INSURANCE = 'COVID_SCREENING_HAS_INSURANCE';
export const SET_PATIENT = `${KEY}.SET_PATIENT`;
export const SET_QUESTIONNAIRE = `${KEY}.SET_QUESTIONNAIRE `;
export const SET_INSURANCE_CARD = `${KEY}.SET_INSURANCE_CARD `;
export const SET_SUBSCRIBER = `${KEY}.SET_SUBSCRIBER `;
export const RESET_COVID_SCREENING = 'RESET_COVID_SCREENING';
export const GET_LIST_INSURANCE = 'GET_LIST_INSURANCE';
export const GET_LIST_INSURANCE_SUCCESS = 'GET_LIST_INSURANCE_SUCCESS';
export const GET_LIST_INSURANCE_FAIL = 'GET_LIST_INSURANCE_FAIL';
export const SET_ORDER_STATUS = 'SET_ORDER_STATUS';

export const setPatient = (patient: Patient) => ({
  type: SET_PATIENT,
  payload: patient
});

export const setQuestionnaire = (questionnaire: Questionnaire) => ({
  type: SET_QUESTIONNAIRE,
  payload: questionnaire
});

export const setInsuranceCard = (insuranceCard: InsuranceCard[] | null) => ({
  type: SET_INSURANCE_CARD,
  payload: insuranceCard
});

export const ADD_INSURANCE_CARD = `${KEY}.ADD_INSURANCE_CARD`;
export const ADD_INSURANCE_CARD_SUCCESS = `${KEY}.ADD_INSURANCE_CARD_SUCCESS`;
export const ADD_INSURANCE_CARD_FAIL = `${KEY}.ADD_INSURANCE_CARD_FAIL`;

export const addInsuranceCard = (
  file?: File,
  uri?: string,
  name?: string,
  type?: string
): Thunk => async dispatch => {
  // eslint-disable-next-line no-undef
  const formData = new FormData();

  // If file then it's web version
  if (file) {
    formData.append('file', file);
  } else {
    const fileToUpload = { uri, type, name };
    formData.append('file', fileToUpload);
  }

  const result = await dispatch({
    type: ADD_INSURANCE_CARD,
    payload: {
      client: 'symptomChecker',
      request: {
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        url: '/covid/upload',
        data: formData
      }
    }
  });

  if (result.error) {
    return {
      error: getErrorMessage(result.error),
      errorCode: getErrorCode(result.error)
    };
  }
  return {
    azureFileName: result.payload?.data?.azureFileName,
    actionStatus: result.payload?.data?.actionStatus
  };
};

export const setSubscriber = (subscriber: Subscriber) => ({
  type: SET_SUBSCRIBER,
  payload: subscriber
});
export const resetCovidScreening = () => ({
  type: RESET_COVID_SCREENING
});
export const SEND_SCREENING_DATA = `${KEY}.SEND_SCREENING_DATA`;
export const SEND_SCREENING_DATA_SUCCESS = `${KEY}.SEND_SCREENING_DATA_SUCCESS`;
export const SEND_SCREENING_DATA_FAIL = `${KEY}.SEND_SCREENING_DATA_FAIL`;
export const sendCovidScreeningData = (data: CovidScreeningState) => ({
  type: SEND_SCREENING_DATA,
  payload: {
    client: 'symptomChecker',
    request: {
      url: `/covid/submitOrder`,
      method: 'post',
      data
    }
  }
});

export const getInsuranceList = () => ({
  type: GET_LIST_INSURANCE,
  payload: {
    client: 'symptomChecker',
    request: {
      url: `/covid/healthPlanList`,
      method: 'GET'
    }
  }
});

export const covidOrderStatus = (data: OrderStatus) => ({
  type: SET_ORDER_STATUS,
  payload: data
});
